"use client";

import React from "react";
import { CircleCheck, Globe, Zap, Wrench } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  title: "זמינות מיידית",
  description: "מענה חירום אמיתי: אנחנו מתחייבים להגעת מטפל סיעודי מקצועי לביתכם או לבתי החולים המובילים כמו שיבא, איכילוב, בילינסון, אסותא וסורוקה תוך 5 שעות בלבד.",
  icon: Zap
}, {
  title: "מטפלים ישראלים",
  description: "ביטחון ושפה משותפת: צוות המטפלים שלנו מורכב מישראלים בלבד, מנוסים בטיפול דמנציה, אלצהיימר, שיקום לאחר אשפוז, המביאים איתם מומחיות רפואית מקומית ויחס חם.",
  icon: CircleCheck
}, {
  title: "פריסה ארצית",
  description: "סטנדרט מקצועי בכל מקום: השירות זמין בפריסה ארצית מלאה עם ניסיון בכל בתי החולים בישראל - מצפון ועד דרום, עם זמינות מיידית בכל עיר ויישוב.",
  icon: Globe
}, {
  title: "ליווי אישי ומקצועי",
  description: "מומחיות בסיעוד: התאמה מדויקת של המטפל לצרכי המטופל תוך עמידה בסטנדרטים רפואיים בינלאומיים, כולל ליווי מקצועי צמוד ופיקוח שוטף.",
  icon: Wrench
}];
export default function WhyChooseUs() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="252304" id="trustbenefitsgrid" className="bg-background text-foreground py-20 md:py-28">
      <div className="page-container">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold font-default text-primary mb-4">
            למה משפחות בוחרות Siudy?
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto font-default">
            השילוב המנצח בין מומחיות רפואית ישראלית לזמינות שיא, המעניק לכם שקט נפשי ברגעים הקריטיים ביותר.
          </p>
        </div>

        <div ref={ref} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <div key={i} data-index={i} className={`transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
            transitionDelay: `${i * 100}ms`
          }}>
                <Card className="h-full bg-card border-border hover:border-accent hover:shadow-lg transition-all duration-300 rounded-lg backdrop-blur-sm">
                  <CardHeader className="pb-4">
                    <div className="w-12 h-12 rounded-lg bg-accent/20 flex items-center justify-center mb-4">
                      <Icon className="w-6 h-6 text-primary" />
                    </div>
                    <CardTitle className="text-xl font-bold font-default text-card-foreground">
                      {feature.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="text-muted-foreground text-base leading-relaxed font-default">
                      {feature.description}
                    </p>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}